'use client';

import { c as _c } from "react/compiler-runtime";
import { useSession } from 'next-auth/react';
import { useParams, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { Loader } from '@module/mdrt-org/shared/components/loader/loader';
import { REDIRECT_URI_AFTER_LOGIN_SEARCH_PARAM_KEY } from '@shared/misc/next-auth/constants';
import { type AuthProviderName } from '@shared/misc/next-auth/enum';
import { useMounted } from '@shared/utils/hooks/use-mounted';
import { usePathname, useRouter } from '../../i18n/i18n-navigation';
import { HOMEPAGE_PATH, LOGIN_PATH, SIGNUP_PATH } from '../../utils/constants/local-paths';
import { loginHandler } from '../../utils/helpers/login-handler';
export const B2CFlowPageContent = t0 => {
  const $ = _c(12);
  const {
    provider
  } = t0;
  const parameters = useParams();
  const {
    status
  } = useSession();
  const isMounted = useMounted();
  const pathname = usePathname();
  const router = useRouter();
  const searchParameters = useSearchParams();
  let t1;
  if ($[0] !== searchParameters) {
    const raw = searchParameters.get(REDIRECT_URI_AFTER_LOGIN_SEARCH_PARAM_KEY);
    t1 = raw?.startsWith("/") ? raw : null;
    $[0] = searchParameters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const redirectAfterLoginPath = t1;
  let t2;
  let t3;
  if ($[2] !== isMounted || $[3] !== parameters.locale || $[4] !== pathname || $[5] !== provider || $[6] !== redirectAfterLoginPath || $[7] !== router || $[8] !== status) {
    t2 = () => {
      if (!isMounted) {
        return;
      }
      const pathnameWithParameters = typeof window === "undefined" ? pathname : window.location.pathname + window.location.search + window.location.hash;
      const redirectToRelative = redirectAfterLoginPath ? redirectAfterLoginPath : pathname === LOGIN_PATH || pathname === SIGNUP_PATH ? HOMEPAGE_PATH : pathnameWithParameters;
      if (status === "authenticated") {
        router.push(redirectToRelative);
        return;
      }
      if (status === "unauthenticated") {
        loginHandler({
          authorizationParameters: {
            ui_locales: parameters.locale as string
          },
          options: {
            redirectTo: redirectToRelative
          },
          provider
        });
      }
    };
    t3 = [isMounted, parameters.locale, pathname, provider, redirectAfterLoginPath, router, status];
    $[2] = isMounted;
    $[3] = parameters.locale;
    $[4] = pathname;
    $[5] = provider;
    $[6] = redirectAfterLoginPath;
    $[7] = router;
    $[8] = status;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Loader />;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};